export default __webpack_public_path__ + "static/media/google-play-button.d30a3346.svg";